import PropTypes from 'prop-types';
import React from 'react';

import CommunityInviteButton from '../../../Community/CommunityInviteButton/CommunityInviteButton';
import CardTitle from '../../../Elements/CardTitle/CardTitle';
import InviteGirls from '../../../SVGs/Groups/InviteGirls/InviteGirls';
import './GroupInviteCTA.scss';

export default class GroupInviteCTA extends React.PureComponent {
    constructor(props) {
        super(props);

        this.baseCls = 'component-Groups-CtaCards-GroupInviteCTA';
    }

    static propTypes = {
        modalTrigger: PropTypes.func.isRequired,
        className: PropTypes.string,
        shareText: PropTypes.string,
        featureFlags: PropTypes.object,
        /**
         * Group data. Can be null, so is not marked as required
         */
        group: PropTypes.shape({
            logo: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }),
            name: PropTypes.string,
            id: PropTypes.number,
            hash: PropTypes.string,
            description: PropTypes.string,
        }),
    };

    static defaultProps = {
        className: '',
        shareText: 'Share this group',
    };

    render() {
        const {
            baseCls,
            props: { modalTrigger, className, shareText, group },
        } = this;

        return (
            <div className={`${baseCls} ${className}`}>
                <CardTitle className={`${baseCls}__title`}>
                    Invite others
                </CardTitle>
                <InviteGirls />
                <p className={`${baseCls}__share-text`}>{shareText}</p>
                <CommunityInviteButton
                    modalTrigger={modalTrigger}
                    group={group}
                    inviteType={'group'}
                    featureFlags={this.props.featureFlags}
                    metricEventType="invite-to-group-click-group-homepage"
                />
            </div>
        );
    }
}
